/**
 * Custom error class for missing route errors
 */
export default class MissingError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = "MissingError";
  }
}
